export default __webpack_public_path__ + "static/media/500.af48ba49.jpg";